import _ from 'lodash';

import { ProtectorType } from 'core/constants';
import { EntityEnumsOptions, EntityType } from 'utils/api/modules/entities/entities.types';

import { FieldType } from 'stores/EntityFields/types';

import { UuidableName } from 'utils/api/types';

import { InitialValues } from './types';

export const transformInitialValues = (en: EntityType): InitialValues => {
  const initialValues: InitialValues = {};
  Object.keys(en).forEach((key) => {
    initialValues[key] = en[key].value;
  });
  return initialValues;
};

export const transformValues = (
  values: InitialValues,
  initialValues: InitialValues,
  entity: EntityType,
  entityFields: FieldType[]
): InitialValues => {
  // Create a copy to avoid mutating the original values object
  const transformedValues = { ...values };

  Object.keys(transformedValues).forEach((key) => {
    // Use deep equality to compare values, not reference equality
    if (_.isEqual(transformedValues[key], initialValues[key])) {
      delete transformedValues[key];
      return;
    }

    const protectorType = entityFields.find((field) => field.id === key)?.protectorType;

    // check if entity[key] exists if not get it from entityFields
    if (!entity[key]) {
      const entityField = entityFields.find((field) => field.id === key);
      if (entityField) {
        entity[key] = {
          // ugly types, because we are sharing types between incidents and entities
          schema: {
            protectorType: entityField.protectorType,
            name: entityField.name,
            type: 'string',
            description: '',
            properties: {},
            order: [],
            enum: entityField.enum?.map((e) => e.key),
          },
          value: null,
        };
      }
    }

    if (protectorType === ProtectorType.Lookup) {
      transformedValues[key] = (transformedValues[key] as UuidableName | null)?.uuid || null;
      return;
    }

    if (protectorType === ProtectorType.User) {
      if (transformedValues[key] === null) {
        transformedValues[key] = null;
      } else {
        transformedValues[key] = (transformedValues[key] as UuidableName | null)?.uuid || null;
      }
    }

    // Handle MultiChoice fields
    if (protectorType === ProtectorType.MultiChoice) {
      if (
        transformedValues[key] === null ||
        transformedValues[key] === undefined ||
        !Array.isArray(transformedValues[key]) ||
        (transformedValues[key] as EntityEnumsOptions[]).length === 0
      ) {
        transformedValues[key] = null;
        return;
      }
      transformedValues[key] = (transformedValues[key] as EntityEnumsOptions[]).map((v) => v.key);
      return;
    }

    // Handle SingleChoice fields
    if (protectorType === ProtectorType.SingleChoice) {
      if (
        transformedValues[key] === null ||
        transformedValues[key] === undefined ||
        !Array.isArray(transformedValues[key]) ||
        (transformedValues[key] as EntityEnumsOptions[]).length === 0
      ) {
        transformedValues[key] = null;
        return;
      }
      transformedValues[key] = [(transformedValues[key] as EntityEnumsOptions[])[0].key];
      return;
    }

    // For other field types, handle null/undefined but don't check for empty arrays
    if (transformedValues[key] === null || transformedValues[key] === undefined) {
      transformedValues[key] = null;
    }
  });
  return transformedValues;
};
